//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// responsive
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// 모달
import BasicBtn from "../../../component/button/BasicBtn";
import CheckBox from "../../../component/button/CheckBox";

export default function SignUp({ setRecommModal, setAgreeModal }) {
    //페이지 이동
    const navigate = useNavigate();
    const goSignComplete = () => {
        navigate(`/signcomplete`);
    };

    // 로그인 창 액티브 스타일
    const [signId, setSignId] = useState(false);
    const [signPw, setSignPw] = useState(false);
    const [signPwCorrect, setSignPwCorrect] = useState(false);
    const [signName, setSignName] = useState(false);
    const [signEmail, setSignEmail] = useState(false);
    const [signReComm, setSignReComm] = useState(false);

    return (
        <Container>
            <SignUpSection>
                <Title>SIGN UP</Title>

                <NoticeText>
                    <span>*</span>필수 입력항목
                </NoticeText>

                <SignForm>
                    {/* 아이디 박스*/}
                    <SignListWrap>
                        <SignTitle htmlFor="email">
                            이메일<span>*</span>
                        </SignTitle>
                        <IdList active={signId.length > 0}>
                            <SignBox
                                id="email"
                                type="text"
                                placeholder="이메일을 입력해주세요."
                                onChange={(e) => {
                                    setSignId(e.target.value);
                                }}
                                required
                            />
                        </IdList>
                        <SameBtn>
                            <BasicBtn text="중복확인" border={true} />
                        </SameBtn>
                    </SignListWrap>

                    {/* 사용 가능한 아이디일때 */}
                    <WarningText>*사용가능한 이메일입니다.</WarningText>
                    {/* 사용 불가능한 아이디일때 */}
                    {/* <WarningText>*사용불가능한 아이디입니다.</WarningText> */}

                    {/* 비밀번호 박스*/}
                    <SignListWrap>
                        <SignTitle htmlFor="pwd">
                            비밀번호<span>*</span>
                        </SignTitle>
                        <SignList active={signPw.length > 0}>
                            <SignBox
                                id="pwd"
                                type="password"
                                placeholder="특수문자 포함 최소 8자 이상으로 조합하여 주세요."
                                onChange={(e) => {
                                    setSignPw(e.target.value);
                                }}
                                required
                            />
                        </SignList>
                    </SignListWrap>
                    {/* 비밀번호가 조건에 맞지 않을때 */}
                    {/* <WarningText>*비밀번호가 조건에 맞지않습니다.</WarningText> */}

                    {/* 비밀번호 확인박스*/}
                    <SignListWrap>
                        <SignTitle htmlFor="pwd2">
                            비밀번호 확인<span>*</span>
                        </SignTitle>
                        <SignList active={signPwCorrect.length > 0}>
                            <SignBox
                                id="pwd2"
                                type="password"
                                placeholder="비밀번호를 입력해주세요."
                                onChange={(e) => {
                                    setSignPwCorrect(e.target.value);
                                }}
                                required
                            />
                        </SignList>
                    </SignListWrap>
                    {/* 비밀번호가 일치하지 않을때 */}
                    {/* <WarningText>*비밀번호가 일치하지않습니다.</WarningText> */}
                    {/* 비밀번호가 일치할때 */}
                    {/* <WarningText>*비밀번호가 일치합니다.</WarningText> */}

                    {/* 이름 박스*/}
                    <SignListWrap>
                        <SignTitle htmlFor="name">
                            이름<span>*</span>
                        </SignTitle>
                        <SignList active={signName.length > 0}>
                            <SignBox
                                id="name"
                                type="text"
                                placeholder="이름을 입력하여주세요."
                                onChange={(e) => {
                                    setSignName(e.target.value);
                                }}
                                required
                            />
                        </SignList>
                    </SignListWrap>

                    {/* 추천인 박스*/}
                    <SignListWrap>
                        <SignTitle htmlFor="recomend">추천인ID</SignTitle>
                        <SignList active={signReComm.length > 0}>
                            <SignBox
                                id="recomend"
                                type="text"
                                placeholder="추천인ID를 입력해주세요."
                                onChange={(e) => {
                                    setSignReComm(e.target.value);
                                }}
                            />
                        </SignList>
                    </SignListWrap>

                    {/* 약관 동의 */}
                    <CheckContent>
                        <CheckBox id="all_agree" text="모든 약관에 동의합니다." />

                        <AgreeBox>
                            <CheckWrap>
                                <CheckList>
                                    <CheckBox id="agree1" text="이용약관 동의" withText={true} option="[필수]" />
                                    <AgreeContents>
                                        <AgreeText>
                                            *******(이하 ‘스토어’ 혹은 ‘회사’)는 서비스기획부터 종료까지 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
                                            ‘정보통신망법’), 개인정보보호법 등 국내의 개인정보 보호 법령을 철저히 준수합니다. 또한, OECD의 개인정보 보호
                                            가이드라인 등 국제 기준을 준수하여 서비스를 제공합니다.본 개인정보 처리방침의 목차는 아래와 같습니다.
                                        </AgreeText>
                                    </AgreeContents>
                                </CheckList>
                                <CheckList>
                                    <CheckBox id="agree2" text="개인정보 수집 및 이용 동의" withText={true} option="[필수]" />
                                    <AgreeContents>
                                        <AgreeText>
                                            *******(이하 ‘스토어’ 혹은 ‘회사’)는 서비스기획부터 종료까지 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
                                            ‘정보통신망법’), 개인정보보호법 등 국내의 개인정보 보호 법령을 철저히 준수합니다. 또한, OECD의 개인정보 보호
                                            가이드라인 등 국제 기준을 준수하여 서비스를 제공합니다.본 개인정보 처리방침의 목차는 아래와 같습니다.
                                        </AgreeText>
                                    </AgreeContents>
                                </CheckList>
                                <CheckList>
                                    <CheckBox id="agree3" text="프로모션 정보 수집 동의" withText={true} option="[선택]" gray={true} />
                                    <AgreeContents>
                                        <AgreeText>
                                            *******(이하 ‘스토어’ 혹은 ‘회사’)는 서비스기획부터 종료까지 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
                                            ‘정보통신망법’), 개인정보보호법 등 국내의 개인정보 보호 법령을 철저히 준수합니다. 또한, OECD의 개인정보 보호
                                            가이드라인 등 국제 기준을 준수하여 서비스를 제공합니다.본 개인정보 처리방침의 목차는 아래와 같습니다.
                                        </AgreeText>
                                    </AgreeContents>
                                </CheckList>
                            </CheckWrap>
                        </AgreeBox>

                        <CheckBtnWrap>
                            <BasicBtn text="취소" gray={true} />

                            <BasicBtn
                                text="확인"
                                onClick={() => {
                                    goSignComplete();
                                }}
                            />

                            {/* 확인 버튼 눌렀을때 추천인 등록안됐을때 / 이용약관 동의 안했을때 팝업이 뜹니다! */}
                            {/* 1. 없는 추천인 아이디 적었을때 팝업 */}
                            {/* <BasicBtn onClick={() => {setRecommModal(true); modalScroll.modalOpen();}} text="확인"/> */}
                            {/* 2. 이용약관 다 동의 안했을때 팝업 */}
                            {/* <BasicBtn onClick={() => {setAgreeModal(true);modalScroll.modalOpen();}} text="확인"/> */}
                        </CheckBtnWrap>
                    </CheckContent>
                </SignForm>
            </SignUpSection>
        </Container>
    );
}

const Container = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;
const SignUpSection = styled.div`
    width: calc(100vw * (625 / 1920));
    margin: calc(100vw * (50 / 1920)) auto calc(100vw * (100 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (625 / 1300));
        margin: calc(100vw * (50 / 1300)) auto calc(100vw * (100 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: ${M(30)} auto ${M(100)};
    }
`;
const Title = styled.h2`
    font-family: "Pop-EL";
    font-size: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-family: "Pop-R";
        font-size: ${M(20)};
    }
`;
const NoticeText = styled.p`
    font-family: "Noto-R";
    text-align: right;
    font-size: calc(100vw * (14 / 1920));

    margin-bottom: calc(100vw * (20 / 1920));

    & span {
        color: var(--main-color);
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(30)};
    }
`;
const SignForm = styled.form``;
const SignList = styled.div`
    display: flex;
    align-items: center;

    width: 100%;
    height: calc(100vw * (45 / 1920));
    padding: calc(100vw * (12 / 1920));

    border-radius: 4px;
    background-color: #fafafa;
    overflow: hidden;

    ${({ active }) => {
        return active ? `border: 1px solid var(--main-color);` : `border: 1px solid #FAFAFA;`;
    }}

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (45 / 1300));
        padding: calc(100vw * (12 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(45)};
        padding: ${M(12)} ${M(15)};
    }
`;
const IdList = styled(SignList)`
    width: calc(100vw * (330 / 1920));
    margin-right: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (330 / 1300));
        margin-right: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(278)};
        margin-right: ${M(10)};
    }
`;
const SameBtn = styled.div`
    width: calc(100vw * (165 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (165 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(90)};
    }
`;
const WarningText = styled.p`
    color: #ef0000;
    font-size: calc(100vw * (14 / 1920));

    margin-top: calc(100vw * (10 / 1920));
    margin-left: calc(100vw * (120 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-top: calc(100vw * (10 / 1300));
        margin-left: calc(100vw * (120 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        margin-top: ${M(13)};
        margin-left: 0;
    }
`;
const SignBox = styled.input`
    width: 100%;
    height: 100%;
    font-size: calc(100vw * (15 / 1920));

    color: #222222;

    &::placeholder {
        color: #dddddd;
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const SignListWrap = styled.div`
    display: flex;
    /* flex-wrap: wrap; */
    align-items: baseline;

    &:not(:first-child) {
        margin-top: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;

        &:not(:first-child) {
            margin-top: ${M(15)};
        }
    }
`;
const SignTitle = styled.label`
    min-width: calc(100vw * (120 / 1920));
    font-size: calc(100vw * (15 / 1920));

    white-space: nowrap;

    & span {
        color: var(--main-color);
    }

    @media screen and (max-width: 1300px) {
        min-width: calc(100vw * (120 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        min-width: auto;
        font-size: ${M(14)};
        width: 100%;

        margin-bottom: ${M(10)};
    }
`;
const CheckContent = styled.div`
    margin-top: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(30)};
    }
`;
const CheckWrap = styled.div``;
const CheckList = styled.div`
    &:not(:first-child) {
        margin-top: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(20)};
        }
    }
`;
const AgreeBox = styled.div`
    width: 100%;
    padding: calc(100vw * (20 / 1920));
    height: calc(100vw * (485 / 1920));
    margin-top: calc(100vw * (20 / 1920));

    background: #fafafa;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300));
        height: calc(100vw * (485 / 1300));
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)};
        /* height: ${M(95)}; */
        height: auto;
        margin-top: ${M(20)};
    }
`;
const AgreeContents = styled.div`
    width: calc(100vw * (580 / 1920));
    height: calc(100vw * (95 / 1920));
    margin-top: calc(100vw * (20 / 1920));
    padding: calc(100vw * (12 / 1920));

    overflow-y: auto;

    background: #fff;
    border: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (580 / 1300));
        height: calc(100vw * (95 / 1300));
        margin-top: calc(100vw * (20 / 1300));
        padding: calc(100vw * (12 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(338)};
        height: ${M(95)};
        margin-top: ${M(20)};
        padding: ${M(8)} ${M(10)};
    }
`;
const AgreeText = styled.p`
    font-size: calc(100vw * (12 / 1920));

    font-family: "Noto-R";
    white-space: pre-line;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (12 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(12)};
    }
`;
const CheckBtnWrap = styled.div`
    width: calc(100vw * (400 / 1920));
    margin: calc(100vw * (40 / 1920)) auto 0;

    display: flex;
    align-items: center;

    & p:first-child {
        margin-right: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));
        margin: calc(100vw * (40 / 1300)) auto 0;

        & p:first-child {
            margin-right: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(340)};
        margin: ${M(50)} auto 0;

        & p:first-child {
            margin-right: ${M(20)};
        }
    }
`;
